import { h, Host } from "@stencil/core";
import { getPlaceholderUrl } from "../../utils/getPlaceholderUrl";
const elementClass = "ux-checkbox-tile";
/**
 * @slot (default) - Used for the ux-checkbox component to be wrapped
 * @slot description - Used to insert a description for the checkbox,
 *                     which can be toggle by clicking on the info icon
 */
export class Checkbox {
    constructor() {
        this.imgSrc = "";
        this.tag = "";
        this.tagColor = "info";
        this.lazyload = false;
        this.imageAlt = "";
        this.checkboxChecked = false;
        this.hasDescription = false;
        this.descriptionActive = false;
    }
    element;
    checkboxInputElement;
    checkboxElement;
    descriptionContainer;
    descriptionToggle;
    componentWillLoad() {
        this.hasDescription = !!this.element.querySelector('[slot="description"]');
    }
    componentDidLoad() {
        this.checkboxInputElement = this.element.querySelector("input[type=checkbox]");
        // @ts-expect-error Check for typing
        this.checkboxElement = this.element.querySelector("ux-checkbox");
        if (this.checkboxInputElement?.checked) {
            this.checkboxChecked = true;
        }
    }
    /** checkbox event, includes checked status, inputId and input name */
    handleActiveState(e) {
        if (this.element.contains(e.target)) {
            if (e.detail.checked) {
                this.checkboxChecked = true;
            }
            else {
                this.checkboxChecked = false;
            }
        }
    }
    handleDescription = () => {
        this.descriptionActive = !this.descriptionActive;
    };
    onElementClick = (e) => {
        if (e.target === this.descriptionContainer) {
            return;
        }
        if (e.target.closest(`.${elementClass}__description--active`)) {
            return;
        }
        if (e.target === this.descriptionToggle) {
            return;
        }
        if (e.target.closest(`.${elementClass}__description-toggle`)) {
            return;
        }
        if (e.target === this.checkboxElement) {
            return;
        }
        if (e.target.closest("ux-checkbox")) {
            return;
        }
        this.checkboxInputElement.click();
    };
    render() {
        return (h(Host, { key: '052669afb7870ec756779bc604e7ae553e89bfd2', class: {
                [elementClass]: true,
                [`${elementClass}--active`]: this.checkboxChecked
            }, onClick: this.onElementClick }, h("div", { key: '1f4605e44a9dea65af6423d19257c26b4561c722', class: `${elementClass}__top-wrapper` }, this.lazyload && (h("picture", { key: '5e0b87639fff38d79d55d3f5de428bd6c68108fe' }, h("img", { key: '49f288fee51f3856ae135e2a51f8940f7e695891', class: "lazyload", src: getPlaceholderUrl(1024, 576), "data-src": this.imgSrc, alt: this.imageAlt }))), !this.lazyload && (h("picture", { key: '35280c90f0556147e52263d3736d886d2b5aaa1b' }, h("img", { key: '3f957e0bbd25c59f4e710c6497ec438e002fc23d', src: this.imgSrc, alt: this.imageAlt }))), this.hasDescription && (h("div", { key: '36c3efd6decb37b78805e3cce5911a5288ec2e87', class: {
                [`${elementClass}__description`]: true,
                [`${elementClass}__description--active`]: this.descriptionActive
            }, "aria-hidden": this.descriptionActive ? "false" : "true",
            // @ts-expect-error Check for typing
            ref: (el) => (this.descriptionContainer = el) }, h("ux-icon", { key: '45d5e65dd9479d3e3f1f1a547004cd74491a316c', name: "cross", weight: "normal", class: `${elementClass}__description-close`, onClick: this.handleDescription, onKeyDown: this.handleDescription, tabindex: "0", "size-s": "13" }), h("slot", { key: '90cdf4dfd37fcf2fe2098c619ff137dccd9d6eaa', name: "description" })))), h("div", { key: 'b826850ddb73d2616c11fed0f251dda3d207a172', class: `${elementClass}__bottom-wrapper` }, this.tag !== "" && h("div", { key: '7279ed60c10267923f67be3456fd6d84a290ce77', class: `${elementClass}__tag ${elementClass}__tag--${this.tagColor}` }, this.tag), h("div", { key: 'c279d8c60d03dd671ec90e0889f6a4b7fcb33f45', class: `${elementClass}__checkbox-container` }, h("slot", { key: 'acc69e8585f684cd8c9095cab1afa7f402437f02' })), this.hasDescription && (h("button", { key: 'c8c012ee0236b7670f2ed978586c9cfd37179e3c', class: `${elementClass}__description-toggle`, onClick: this.handleDescription, type: "button",
            // @ts-expect-error Check for typing
            ref: (el) => (this.descriptionToggle = el) }, h("ux-icon", { key: 'fd8f9c9767c27e4fe2f60d7a01ef981b1cc7d8f9', name: "square-info", weight: "bold", "size-s": "15" }))))));
    }
    static get is() { return "ux-checkbox-tile"; }
    static get originalStyleUrls() {
        return {
            "$": ["checkbox-tile.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["checkbox-tile.css"]
        };
    }
    static get properties() {
        return {
            "imgSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the image url for the media element of the checkbox"
                },
                "attribute": "img-src",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "tag": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "optional text of the tag"
                },
                "attribute": "tag",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "tagColor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"warning\" | \"info\"",
                    "resolved": "\"info\" | \"warning\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "color of the tag"
                },
                "attribute": "tag-color",
                "reflect": false,
                "defaultValue": "\"info\""
            },
            "lazyload": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "optional lazyloading of images"
                },
                "attribute": "lazyload",
                "reflect": false,
                "defaultValue": "false"
            },
            "imageAlt": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "alt image tag"
                },
                "attribute": "image-alt",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "checkboxChecked": {},
            "hasDescription": {},
            "descriptionActive": {}
        };
    }
    static get elementRef() { return "element"; }
    static get listeners() {
        return [{
                "name": "uxCheckboxChange",
                "method": "handleActiveState",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=checkbox-tile.js.map
